import {makeAutoObservable} from 'mobx';
import filtersStore from '../filters/filters-store';

class PriceRangeStore {
    public min: number = 0;
    public max: number = 500;
    public range: number[] = [this.min, this.max];

    constructor() {
        makeAutoObservable(this);
    }

    setPriceRange = async (range: number[], forceRender = false) => {
        if (forceRender || this.range[0] !== range[0]) {
            await filtersStore.updateFilter('priceMin', range[0]);
        }

        if (forceRender || this.range[1] !== range[1]) {
            await filtersStore.updateFilter('priceMax', range[1]);
        }

        this.range = range;
    };

    setMinValue = async (value: number) => {
        if (value === 0 || value > this.max) {
            await this.setPriceRange([this.min, this.range[1]], value !== this.min);

            return;
        }

        if (value < this.max && value <= this.range[1]) {
            await this.setPriceRange([value, this.range[1]]);
        }
    };

    setMaxValue = async (value: number) => {
        if (value === 0 || value > this.max) {
            await this.setPriceRange([this.range[0], this.max], value !== this.max);

            return;
        }

        if (value > this.min && value >= this.range[0]) {
            await this.setPriceRange([this.range[0], value]);
        }
    };
}

const priceRangeStore = new PriceRangeStore();

export default priceRangeStore;
